import Vue from 'vue'

export function createComponent (element, component, props) {
  new Vue({ // eslint-disable-line no-new
    el: element,

    render: function (h) {
      return h(component, {props: props})
    }
  })
}



// WEBPACK FOOTER //
// ./src/shared/createComponent.js